import { render, staticRenderFns } from "./CardGroup.vue?vue&type=template&id=30184806&"
import script from "./CardGroup.vue?vue&type=script&lang=js&"
export * from "./CardGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports